﻿import React, { useState, useEffect, useImperativeHandle, useContext, useRef } from "react";
import { Container, Row, Col, Modal, Button, Alert } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import googleImg from "./../../../Images/google-img.png";
import closeIcon from "./../../../Images/close-icon.png";
import cross from "./../../../Images/cross.png";
import LogoWhite from "./../../../Images/logo-white.png";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState,setState, signupUser, forgotpassword, checkvalidotp, userupdatepassword, userupdateusername, signinemailpassword, ValidateMobile } from '../../features/User/UserSlice';
import { gapi } from 'gapi-script';
import { GoogleLogin } from 'react-google-login';
import URLstateContext from "../../../provider/CommonContext";
import "./Loginpopup.css";
import { FaEye, FaEyeSlash, FaUser, FaPhone,  FaRupeeSign } from "react-icons/fa";
import sha256 from 'crypto-js/sha256';
import { Vortex } from 'react-loader-spinner'
import jwt_decode from 'jwt-decode';
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import TrackApi from "../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";
import { Apiurl } from "../../Configuration/configuration";
import Slider from "react-slick";
import Swal from "sweetalert2";
import { ApiUrlDomain } from "../../Configration/Configrationnew";
import { VApiSignup } from "./VApiSignup";

function LoginPopup(props, ref) {
    const { clientId } = useContext(URLstateContext);
    const [modelshow, setShow] = useState(false);
    const handleClose = () => { setShow(false); setNewUserMobNo(''); setNewUserMoberror(''); setemailerror(''); setemail('');Setnewmobotpverify(false) }
    const [email, setemail] = useState('');
    const [emailerror, setemailerror] = useState('');
    const [otperror, setotperror] = useState('');
    const dispatch = useDispatch();
    const [password, setpassword] = useState('');
    const [passworderror, setpassworderror] = useState('');
    const [isGoogleLoginOpened, setisGoogleLoginOpened] = useState(true);
    const [isForgotdiv, setisForgotdiv] = useState(false);
    const [otp, setotp] = useState('');
    const [otpnew, setOtpnew] = useState('');
    const [isOTPdiv, setisOTPdiv] = useState(false);
    const [isuseridpassword, setisuseridpassword] = useState(false);
    const [isnewpassword, setisnewpassword] = useState(false);
    const [mobile_l, setMobile_l] = useState('');
    const [newpassword, setnewpassword] = useState('');
    const [newpassworderror, setnewpassworderror] = useState('');
    const [passwordtype, setpasswordtype] = useState('password');
    const [confrimpasswordtype, setconfrimpasswordtype] = useState('password');
    const [loadingshow, setloadingshow] = useState(false);
    const [showmobile, setshowmobile] = useState(false);
    const [newmobotpverify, Setnewmobotpverify] = useState(false);
    const [verifyloader, setverifyloader] = useState(false);
    const [loadingshowgoogle, setloadingshowgoogle] = useState(false);

    const [confirmnewpassword, setconfirmnewpassword] = useState('');
    const [confirmnewpassworderror, setconfirmnewpassworderror] = useState('');
    const [commonnewpassworderror, setcommonnewpassworderror] = useState('');
    const [eye, seteye] = useState(true);
    const [confirmeye, setconfirmeye] = useState(true);
    //User Firstname and Lastname
    const [isusername, setissusername] = useState(false);
    const [newuserfirstname, setnewuserfirstname] = useState('');
    const [nameUrl, setNameUrl] = useState('');
    const [nameNew, setNameNew] = useState('');
    const [userfirstnameError, setUserfirstnameError] = useState('');
    const [newuserlastname, setnewuserlastname] = useState('');
    const [mob_no, setNewUserMobNo] = useState([]);
    const [resp_mob_no, setRespNewUserMobNo] = useState([]);
    const [resp_mob_no_update, setRespNewUserMobNoupdate] = useState([]);
    const [disabledmobile, setdisabledmobile] = useState(true);
    const [newuserfirstnameerror, setnewuserfirstnameerror] = useState('');
    const [newuserlastnameerror, setnewuserlastnameerror] = useState('');
    const [newUserMoberror, setNewUserMoberror] = useState('');
    const [NameUser, setNameUser] = useState('');

    const [isthankyou, setisthankyou] = useState(false);
    const [eyenew, setneweye] = useState(true);
    const [passwordnewtype, setpasswordnewtype] = useState('password');
    const { CRMBaseURL } = useContext(URLstateContext);
    const [isDisabled, setIsDisabled] = useState(false)
    const divRef = useRef(null);

    const [user, setUser] = useState([]);
    const [cookies, setCookie] = useCookies(['LeadId']);

    const [otpis1,setotpis1]=useState('');
    const [otpis2,setotpis2]=useState('');
    const [otpis3,setotpis3]=useState('');
    const [otpis4,setotpis4]=useState('');
    // const fetchData = () => {
    //   return fetch("../../api/Login/ValidateMobile")
    //         // .then((response) => response.json())
    //         .then((data) => setUser(data));
    // }
    const [seconds, setSeconds] = useState(30);
    const [resendDisabled, setResendDisabled] = useState(true);

    let navigate = useNavigate();
   
    useImperativeHandle(ref, () => ({
        changeTogglePopup: (hideshow) => {
            setisGoogleLoginOpened(true);
            setisuseridpassword(false);
            setissusername(false);
            setconfirmnewpassword(false);
            setisOTPdiv(false);
            setisnewpassword(false);
            setisthankyou(false);
            setisForgotdiv(false);
            setpassworderror("");
            setShow(hideshow);
        }
    }));
    // if(modelshow){
    //     setShow(false);
    //     window.open('https://ekyc.moneysukh.com:8443/Index.aspx');
    // }
    const settings = {
        autoplay:true,
        dots: false,
        prevArrow: false,
        nextArrow: false,
        arrows: false,
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 1,
        slidesToScroll: 1,
       
      };
    const usrname = useSelector(state => state.user.email);
    const { flg_mobValidated, isFetching, isSuccess, isError, errorMessage, isforgot, isotpflag, isnewpassflag, isupdflag, isusernameflag, isCRMuser } = useSelector(
        userSelector
    );

    function handleCredentialResponse(response) {
        // console.log("response:" + JSON.stringify(response.credential));
        var userobj = jwt_decode(response.credential);
        // console.log(userobj);
        onSuccess(userobj);
    }

    useEffect(() => {
        /* global google */

        if (divRef.current) {
            google.accounts.id.initialize({
                client_id: clientId,
                callback: handleCredentialResponse
            });
            google.accounts.id.renderButton(document.getElementById("signInDiv"), {
                type: "standard", theme: "outline", size: "large", shape: "rectangular", width: "100%", logo_alignment: "left"


            });
            google.accounts.id.prompt();
        }
    });



    const onSuccess = (res) => {
        var websiteurl = window.location.href;
        //console.log("res: " + res)

        alert(
            `Logged in successfully welcome ${res.name} 😍.`
        );
        setloadingshowgoogle(true);
        var data = {
            "name": res.name, "email": res.email, "googleid": res.jti, "tokenid": res.jti,
            "accesstoken": res.jti, "imgurl": res.picture, "familyname": res.family_name,
            "givenName": res.given_name, "nameNew": res.name, "mob_no": mob_no, "websiteurl": websiteurl
        }
        //console.log("data:" + JSON.stringify(data));
         //  lead creat api
      let bodydataleadapi=[
        {
        "Attribute": "EmailAddress",
        "Value": res.email
        },{
          "Attribute": "Phone",
          "Value": mob_no
          },{
            "Attribute": "mx_Primary_Email_ID",
            "Value":res.email
            },{
              "Attribute": "SearchBy",
              "Value":"mx_Primary_Email_ID"
              },];
      
      axios
      .post("https://api-in21.leadsquared.com/v2/LeadManagement.svc/Lead.CreateOrUpdate?postUpdatedLead=false&accessKey=eee&secretKey=eee", bodydataleadapi).then(async(responelead)=>{
        console.log("uhhhhhh",responelead.data.Message);
       const leadId=await responelead.data.Message && responelead.data.Message.Id;
       setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
       const payloadData={
        "RelatedProspectId":leadId,
        "ActivityNote": "Your Activity Note",
        "mx_Custom_1": "Home",
        "mx_Custom_2": "Your Activity Note",
        "mx_CustomObject_81":window.location.href
       }
       TrackApi(payloadData);
      })
//  lead api end code 
        setloadingshowgoogle(true);
        dispatch(signupUser(data));
    };



    useEffect(() => {

        if (isSuccess) {
            //console.log("isCRMuser" + isCRMuser);
            setShow(false);
        setloadingshowgoogle(false);


        }

        if (isforgot) {
            //console.log("Raviuday");
        }

        if (isError) {
            setpassworderror("Invalid userid and password");
            //console.log(errorMessage);
            dispatch(clearState());
        }


    }, [isSuccess, isError, isforgot]);

    const ValidateMobileNumber = () => {

    }


    const onFailure = (err) => {
        // console.log('failed:', err);
    };
    const onLogoutSuccess = (res) => {
        //console.log('Logged out Successfully:', res);
        localStorage.removeItem('token');

        alert('Logged out Successfully ✌');
        window.location.reload();
    }

    useEffect(() => {
        if (isotpflag) {
            //console.log("Raviuday");
            setisOTPdiv(false);
            setisnewpassword(true);
        }
        else {
            setotperror('Please enter valid OTP')
        }
    }, [isotpflag]);

    useEffect(() => {
        if (isupdflag) {
            if (isnewpassflag) {
                setisnewpassword(false);
                setissusername(true);
            }
            else {
                setloadingshow(false);
                setisnewpassword(false);
                setisthankyou(true);
                setIsDisabled(false);
            }
        }


    }, [isnewpassflag, isupdflag]);

    useEffect(() => {
        if (isusernameflag) {
            setIsDisabled(false);
            setloadingshow(false);
            setissusername(false);
            setisthankyou(true);

        }

    }, [isusernameflag]);

    // const loginwithMobile = () => {

    //     if (newUserMobNo == "") {
    //         setNewUserMoberror("Please Enter Mobile Number");
    //         return false;
    //     }
    // }
    const handleClosePopup = () => {
        setshowmobile(false);
    }

    const [post, updatePost] = useState({ mob_no: '' })
    const loginwithemailnewflow=()=>{
        if (mob_no != "" && mob_no.toString().length === 10) {
            // for registration otp send
          
axios.get(`${ApiUrlDomain}/otpSend?phone_no=${mob_no}`).then((res)=>{
        if(res.data=='OTP sent successfully'){
            setotpis1('')
            setotpis2('')
            setotpis3('')
            setotpis4('')
            setisGoogleLoginOpened(false);
            Setnewmobotpverify(true);
            setshowmobile(false);
            setSeconds(30);
            setResendDisabled(true);
    }
  
}).catch((error)=>{
    console.log(error);
})
                                           
        }
            else {
                setNewUserMoberror("Please enter valid mobile number");
                return false;
            }
        
    }
    const loginwithemail = () => {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        // if (email == "") {
        //     setemailerror("Please enter email address");
        //     return false;
        // }

        if (mob_no != "" && mob_no.toString().length === 10) {
            // if (re.test(email)) {
            if (true) {
                setisGoogleLoginOpened(false);
                Setnewmobotpverify(true);
                setshowmobile(false);
                return;
                axios.post(`${Apiurl}/api/Login/ValidateMobile`, { 'email': email, "mob_no": mob_no })
                    .then(function (response) {
                        if (response.data.success === true) {
                            if (response.data.data.mob_no == mob_no) {
                                setisGoogleLoginOpened(false);
                                setisuseridpassword(true);
                                return false;
                            }
                            if (mobile_l >= 9) {
                                setshowmobile(true);
                            }
                            setRespNewUserMobNoupdate(response.data.data.mob_no)
                            var str = response.data.data.mob_no;
                            var replaced = str.replace(/.(?=.{4,}$)/g, '*');
                            setRespNewUserMobNo(replaced)
                        } else {
                            setshowmobile(false);
// lead creat api
let bodydataleadapi=[
    {
    "Attribute": "EmailAddress",
    "Value": email
    },{
      "Attribute": "Phone",
      "Value": mob_no
      },{
        "Attribute": "mx_Primary_Email_ID",
        "Value":email
        },{
          "Attribute": "SearchBy",
          "Value":"mx_Primary_Email_ID"
          },];
  
  axios
  .post("https://api-in21.leadsquared.com/v2/LeadManagement.svc/Lead.CreateOrUpdate?postUpdatedLead=false&accessKey=eeee&secretKey=eee", bodydataleadapi).then(async(responelead)=>{
    console.log("uhhhhhh",responelead.data.Message);
   const leadId=await responelead.data.Message && responelead.data.Message.Id;
   setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
   const payloadData={
    "RelatedProspectId":leadId,
    "ActivityNote": "Your Activity Note",
    "mx_Custom_1": "Home",
    "mx_Custom_2": "Your Activity Note",
    "mx_CustomObject_81":window.location.href
   }
   TrackApi(payloadData);
  })
// lead creat api end code
                            axios.post(`${Apiurl}/api/Login/UpdateMobile`, { 'email': email, "mob_no": mob_no })
                                .then(function (response) {
                                    if (response.data.success === true) {
                                        setisGoogleLoginOpened(false);
                                        setisuseridpassword(true);
                                        setshowmobile(false);
                                        return true;
                                    }
                                })
                            setemailerror("Please enter valid email address");
                        }
                    })
                    .catch(function (response) {

                    });
            } else {
                setemailerror("Please enter valid email address");
                return false;
            }
        } else {
            setNewUserMoberror("Please enter valid mobile number");
            return false;
        }

        const reMob = /^[0-9\b]+$/;
        // if (mob_no == "") {
        //     setNewUserMoberror("Please enter valid mobile number");
        //     return false;
        // }
        // else {
        //     setNewUserMoberror("Please enter valid mobile number");
        //     return false;
        // }



    };
    const mobileerror = (event) => {
        const re = /^[0-9\b]+$/;
        if (mob_no == "") {
            setNewUserMoberror("Please enter valid mobile number");
            return false;
        }
        else {
            setNewUserMoberror("Please enter valid mobile number");
            return false;
        }
    }
    const updateMobile = () => {
        axios.post("/api/Login/UpdateMobile", { 'email': email, "mob_no": mob_no })
            .then(function (response) {
                if (response.data.success === true) {
                    // handleShow("");
                    // alert("Data not submitted!!! Please Try Again")
                    setisGoogleLoginOpened(false);
                    setisuseridpassword(true);
                    setshowmobile(false);
                    return true;
                }
                else {
                    // alert("Data not submitted!!! Please Try Again")
                    // setisuseridpassword(true);
                }

            })
            .catch(function (response) {

            });

    }
    const handleNewUserMobileNumber = event => {

        // if(event.target.value.length  == "" && event.target.value.length <= 10 ){
        //     document.getElementById('error').style.display ="block";
        // }
        // else{
        //     document.getElementById('error').style.display ="none";
        // }
        const re = /^[0-9\b]+$/;
        setMobile_l(event.target.value.length);
        if (event.target.value.length <= 10 && re.test(event.target.value)) {
            setNewUserMobNo(parseInt(event.target.value));
        }

        if (event.target.value.length == 0) {
            setNewUserMobNo("");
        }
        setNewUserMoberror("");

    };

    const handleUsername = event => {
        const re = /^[A-Za-z\s]*$/;
        if (event.target.value === "" || re.test(event.target.value)) {
            setNameNew(event.target.value);
        }
        setUserfirstnameError("");
    };

    const loginsubmit = () => {
    }
    const handleChange = event => {
        setemail(event.target.value);
        setemailerror("");

    };
    const handleChangepassword = event => {
        setpassword(event.target.value);
        setpassworderror("");

    };
    const loginwithpassword = () => {

        if (password == "") {
            setpassworderror("Please enter password");
            return false;
        }
        var passencrypted = base64_encode(password);

        var data = {
            "email": email,
            "password": passencrypted
        }
        dispatch(signinemailpassword(data));

    }
    const OTPsend = () => {
        var data = {
            "email": email,
            "mob_no": mob_no
        }
        dispatch(forgotpassword(data));
        setisForgotdiv(false);
        setisOTPdiv(true);

    }
    const functionforgotpassword = () => {
        setisuseridpassword(false);
        setisForgotdiv(true);

    }
    const handleChangeOTP = event => {
        setotp(event.target.value);
    };
    const changepassword = () => {
        //console.log("otp:" + otp);
        if (otp == "") {
            setotperror("Please enter OTP");
            return false;
        }
        else {
            var data = {
                "email": email,
                "otp": otp
            }
            dispatch(checkvalidotp(data));
        }
    }
    const handlenewChangepassword = event => {
        setnewpassword(event.target.value);
        setnewpassworderror("");

    };
    const handleconfirmnewpassword = event => {
        setconfirmnewpassword(event.target.value);
        setconfirmnewpassworderror("");

    };
    const updatepassword = event => {
        var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

        if (newpassword == "") {
            setnewpassworderror("Please enter new password");
            return false;
        }
        if (re.test(newpassword)) {
        }
        else {
            setnewpassworderror("Please enter valid password");
            return false;
        }
        if (confirmnewpassword == "") {
            setconfirmnewpassworderror("Please enter new confirm password");
            return false;
        }

        if (re.test(confirmnewpassword)) {
            //setnewpassworderror("Password valid");
        }
        else {
            setconfirmnewpassworderror("Please enter valid password");
            return false;
        }
        if (newpassword != confirmnewpassword) {
            setcommonnewpassworderror("Both Password and Confirm Password must be same.");
            return false;
        }

        var passencrypted = base64_encode(newpassword);

        var data = {
            "email": email,
            "password": passencrypted
        }
        dispatch(userupdatepassword(data));

    };
    const funEye = () => {
        if (passwordtype == "password") {
            setpasswordtype("text");
            seteye(false);

        }
        else {
            setpasswordtype("password");
            seteye(true);

        }
    }
    const funconfirmEye = () => {
        if (confrimpasswordtype == "password") {
            setconfrimpasswordtype("text");
            setconfirmeye(false);

        }
        else {
            setconfrimpasswordtype("password");
            setconfirmeye(true);

        }
    }
    const routeChange = () => {
        window.location.reload();
    };
    const handlenewusername = event => {
        const re = /^[A-Za-z]+$/;
        const { value } = event.target;
        if (value === "" || re.test(value)) {
            setnewuserfirstname(value);
        }
        //setnewuserfirstname(event.target.value);
        setnewuserfirstnameerror("");

    };
    const handlenewuserlastname = event => {
        const re = /^[A-Za-z]+$/;
        const { value } = event.target;
        if (value === "" || re.test(value)) {
            setnewuserlastname(value);
        }
        setnewuserlastnameerror("");
    };

    const handleNewUserMobileNumberNew = event => {
        const re = /^[0-9\b]+$/;
        if (event.target.value.length <= 10 && re.test(event.target.value)) {
            setNewUserMobNo(parseInt(event.target.value));

        }
        setMobile_l(event.target.value.length);
        if (event.target.value.length == 0) {
            setNewUserMobNo("");
        }
        setNewUserMoberror("");
    };

    const updatefirstlastname = event => {
        setIsDisabled(true);
        var re = /^(?=.*\d)(?=.*[a-z][A-Z]).{8,}$/;
        var remob = /^[0-9\b]+$/;

        if (newuserfirstname == "") {
            setnewuserfirstnameerror("Please enter first name");
            setIsDisabled(false);
            return false;
        }

        if (newuserlastname == "") {
            setnewuserlastnameerror("Please enter last name");
            setIsDisabled(false);

            return false;
        }

        if (mobile_l == "" || mobile_l <= 9) {
            setNewUserMoberror("Please enter Mobile No.");
            setIsDisabled(false);

            return false;
        }



        setloadingshow(true);
        setIsDisabled(true);
        let userfullname = newuserfirstname + " " + newuserlastname;
        var websiteurl = window.location.href;
        var data = {
            "email": email,
            "username": userfullname,
            "mob_no": mob_no,
            "websiteurl": websiteurl
        }

        dispatch(userupdateusername(data));
        setIsDisabled(true);
    };

    const funEyenew = () => {
        if (passwordnewtype == "password") {
            setpasswordnewtype("text");
            setneweye(false);

        }
        else {
            setpasswordnewtype("password");
            setneweye(true);

        }
    }

const handleChangeOTPNew=(e)=>{
setOtpnew(e.target.value);
}

const NewsignFlow=()=>{
    // for mobile otp verify
    const fullOtp = otpis1 + otpis2 + otpis3 + otpis4;
    var mob_nonewflow=mob_no;
    setverifyloader(true);
    axios.get(`${ApiUrlDomain}/otpValidate?phone_no=${mob_no}&otp=${fullOtp}`).then((res)=>{
if(res.data=='OTP validated successfully'){
     axios.post(`${ApiUrlDomain}/signupRetriveLead`,{"phone":mob_no}).then((res)=>{
        
            if(res && res.data.length>0){
          
        //     const reduxjson={
        //         "email": mob_no,
        // "name": NameUser,
        //         "ProspectStage": res.data[0].prospectStage,
        //         "mx_Lead_Status": res.data[0].mx_Lead_Status,
        //         "mx_Status": res.data[0].mx_Status
        //     };
            
            const leadId=res.data[0].prospectID;
               setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
               const payloadData={
                "RelatedProspectId":leadId,
                "ActivityNote": "Your Activity Note",
                "mx_Custom_1": "Home",
                "mx_Custom_2": "Your Activity Note",
                "mx_CustomObject_81":window.location.href
               }
               
               if(res.data[0].prospectStage=="Customer" && res.data[0].mx_Lead_Status=="Active" && res.data[0].mx_Status=="Enabled"){
                dispatch(setState({
                    "email": mob_no,
            "name": NameUser,
                    "ProspectStage": res.data[0].prospectStage,
                    "mx_Lead_Status": res.data[0].mx_Lead_Status,
                    "mx_Status": res.data[0].mx_Status
                }));
                localStorage.setItem('userlogin',true);
                localStorage.setItem('email',mob_no);
                localStorage.setItem('ProspectStage',res.data[0].prospectStage);
                localStorage.setItem('mx_Lead_Status',res.data[0].mx_Lead_Status);
                localStorage.setItem('mx_Status',res.data[0].mx_Status);
                localStorage.setItem('name',NameUser);
                localStorage.setItem('token',"jhjsdhjhjhd");
                Setnewmobotpverify(false);
        setverifyloader(false);
        TrackApi(payloadData);
            setNewUserMobNo('');
                window.open('https://online.moneysukh.com');
                
               }else{
axios.post(`${ApiUrlDomain}/signupnewuser`,{Mobile:mob_no,mx_Vendor_Unique_Id:res.data[0].mx_Vendor_Unique_Id}).then((resn)=>{
  
        dispatch(setState({
                "email": mob_no,
        "name": NameUser,
                "ProspectStage": res.data[0].prospectStage,
                "mx_Lead_Status": res.data[0].mx_Lead_Status,
                "mx_Status": res.data[0].mx_Status
            }));
            localStorage.setItem('userlogin',true);
            localStorage.setItem('email',mob_no);
            localStorage.setItem('ProspectStage',res.data[0].prospectStage);
            localStorage.setItem('mx_Lead_Status',res.data[0].mx_Lead_Status);
            localStorage.setItem('mx_Status',res.data[0].mx_Status);
            localStorage.setItem('name',NameUser);
            localStorage.setItem('token',"jhjsdhjhjhd");
            Setnewmobotpverify(false);
    setverifyloader(false);
        setNewUserMobNo(''); 
        
        if(resn && resn.data && resn.data.uniqueid){
            axios.post(`${ApiUrlDomain}/lsqupdate`, {
                "LeadId":leadId,
                "mx_Vendor_Unique_Id":resn.data.uniqueid
            }).then((tt)=>{
    
            }).catch((errd)=>{
                console.log(errd);
            })
        }
       

        let redirecturlsignup = document.createElement('a');
        redirecturlsignup.href = resn.data.data[0].url;
        redirecturlsignup.target = '_blank';
        redirecturlsignup.style.display = 'none';
        document.body.appendChild(redirecturlsignup);
        redirecturlsignup.click();
        document.body.removeChild(redirecturlsignup); 
            TrackApi(payloadData);
            
}).catch((error)=>{
    dispatch(setState({
        "email": mob_no,
"name": NameUser,
        "ProspectStage": res.data[0].prospectStage,
        "mx_Lead_Status": res.data[0].mx_Lead_Status,
        "mx_Status": res.data[0].mx_Status
    }));
    localStorage.setItem('userlogin',true);
    localStorage.setItem('email',mob_no);
    localStorage.setItem('ProspectStage',res.data[0].prospectStage);
    localStorage.setItem('mx_Lead_Status',res.data[0].mx_Lead_Status);
    localStorage.setItem('mx_Status',res.data[0].mx_Status);
    localStorage.setItem('name',NameUser);
    localStorage.setItem('token',"jhjsdhjhjhd");
    Setnewmobotpverify(false);
setverifyloader(false);
setNewUserMobNo(''); 
let redirecturlsignup = document.createElement('a');
redirecturlsignup.href = "https://kyc.moneysukh.com";
redirecturlsignup.target = '_blank';
redirecturlsignup.style.display = 'none';
document.body.appendChild(redirecturlsignup);
redirecturlsignup.click();
document.body.removeChild(redirecturlsignup); 
    TrackApi(payloadData);
    setverifyloader(false);
    console.log(error);
})

                // VApiSignup(mob_nonewflow,payloadData,reduxjson,dispatch,setState,Setnewmobotpverify,setverifyloader);
                // window.open('https://kyc.moneysukh.com');
               }
            //    TrackApi(payloadData);
              
        }else{
            axios.post(`${ApiUrlDomain}/signupnewuser`,{Mobile:mob_no,mx_Vendor_Unique_Id:""}).then((resurl)=>{
                Setnewmobotpverify(false);
                setverifyloader(false);
                     dispatch(setState({
                    "email": mob_no,
                    "name": NameUser
                }));
                const reduxjson={
                    "email": mob_no,
                    "name": NameUser
                };
                localStorage.setItem('userlogin',true);
                localStorage.setItem('email',mob_no);
                localStorage.setItem('name',NameUser);
                localStorage.setItem('token',"jhjsdhjhjhd");
                // Setnewmobotpverify(false);
            setNewUserMobNo('');
             // lead creat api
        let bodydataleadapi=[
            {
            "Attribute": "EmailAddress",
            "Value": email
            },{
              "Attribute": "Phone",
              "Value": mob_no
              },{
                "Attribute": "mx_Primary_Email_ID",
                "Value":email
                },{
                  "Attribute": "SearchBy",
                  "Value":"mx_Primary_Email_ID"
                  },{
                    "Attribute": "Source",
                    "Value":"Website"
                    },{
                        "Attribute": "FirstName",
                        "Value":NameUser
                        },
                        {
                            "Attribute": "mx_Vendor_Unique_Id",
                            "Value":resurl.data.uniqueid
                            },
                         {
                            "Attribute": "mx_website_URL_React",
                            "Value":window.location.href
                            }         
                    
                    ];
          
          
       axios.post(`${ApiUrlDomain}/signupCreateLead`, bodydataleadapi).then(async(responelead)=>{
            console.log("uhhhhhh",responelead);
        //    const leadId=await responelead.data.Message && responelead.data.Message.Id;
           const leadId=responelead && responelead.data&&responelead.data.leadId;
           setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
           const payloadData={
            "RelatedProspectId":leadId,
            "ActivityNote": "Your Activity Note",
            "mx_Custom_1": "Home",
            "mx_Custom_2": "Your Activity Note",
            //binda
            "mx1_Referred_by": "",
            "mx_CustomObject_81":window.location.href
           }
        //    VApiSignup(mob_nonewflow,payloadData,reduxjson,dispatch,setState,Setnewmobotpverify,setverifyloader);
        //    TrackApi(payloadData);
        TrackApi(payloadData);
          }).catch((error)=>{
            setverifyloader(false);
          })
        // lead creat api end code
                    // window.open('https://kyc.moneysukh.com');
                    let redirecturlsignup = document.createElement('a');
                    redirecturlsignup.href = resurl.data.data[0].url;
                    redirecturlsignup.target = '_blank';
                    redirecturlsignup.style.display = 'none';
                    document.body.appendChild(redirecturlsignup);
                    redirecturlsignup.click();
                    document.body.removeChild(redirecturlsignup); 
            
                       
                        
            }).catch((error)=>{
                //setverifyloader(false);
                console.log(error);
                Setnewmobotpverify(false);
                setverifyloader(false);
                     dispatch(setState({
                    "email": mob_no,
                    "name": NameUser
                }));
                const reduxjson={
                    "email": mob_no,
                    "name": NameUser
                };
                localStorage.setItem('userlogin',true);
                localStorage.setItem('email',mob_no);
                localStorage.setItem('name',NameUser);
                localStorage.setItem('token',"jhjsdhjhjhd");
                // Setnewmobotpverify(false);
            setNewUserMobNo('');
             // lead creat api
        let bodydataleadapi=[
            {
            "Attribute": "EmailAddress",
            "Value": email
            },{
              "Attribute": "Phone",
              "Value": mob_no
              },{
                "Attribute": "mx_Primary_Email_ID",
                "Value":email
                },{
                  "Attribute": "SearchBy",
                  "Value":"mx_Primary_Email_ID"
                  },{
                    "Attribute": "Source",
                    "Value":"Website"
                    },{
                        "Attribute": "FirstName",
                        "Value":NameUser
                        },
                        {
                            "Attribute": "mx_Vendor_Unique_Id",
                            "Value":""
                            },
                      {
                            "Attribute": "mx_website_URL_React",
                            "Value":window.location.href
                            }            
                    
                    ];
          
          
       axios.post(`${ApiUrlDomain}/signupCreateLead`, bodydataleadapi).then(async(responelead)=>{
            console.log("uhhhhhh",responelead);
        //    const leadId=await responelead.data.Message && responelead.data.Message.Id;
           const leadId=responelead && responelead.data&&responelead.data.leadId;
           setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
           const payloadData={
            "RelatedProspectId":leadId,
            "ActivityNote": "Your Activity Note",
            "mx_Custom_1": "Home",
            "mx_Custom_2": "Your Activity Note",
            "mx_CustomObject_81":window.location.href
           }
        //    VApiSignup(mob_nonewflow,payloadData,reduxjson,dispatch,setState,Setnewmobotpverify,setverifyloader);
        //    TrackApi(payloadData);
        TrackApi(payloadData);
          }).catch((error)=>{
            setverifyloader(false);
          })
        // lead creat api end code
                    // window.open('https://kyc.moneysukh.com');
                    let redirecturlsignup = document.createElement('a');
                    redirecturlsignup.href = 'https://kyc.moneysukh.com';
                    redirecturlsignup.target = '_blank';
                    redirecturlsignup.style.display = 'none';
                    document.body.appendChild(redirecturlsignup);
                    redirecturlsignup.click();
                    document.body.removeChild(redirecturlsignup); 
            
                       
              
            })
        
                // window.open('https://kyc.moneysukh.com/');
                
        }
        
        }).catch((error)=>{
            console.log(error);
            setverifyloader(false);
        })




    
   
}else if(res.data=='Invalid OTP'){
Swal.fire(`Invalid OTP Please Enter Correct Otp`);
setverifyloader(false);
}
   
    }).catch((error)=>{
        setverifyloader(false);
        console.log(error);
    })
    
}
useEffect(()=>{
    const inputs = document.querySelectorAll('#otp1, #otp2, #otp3, #otp4');
    
    inputs.forEach((input, index) => {
      input.addEventListener('input', () => {
        if (input.value.length === 1 && index < inputs.length - 1) {
          inputs[index + 1].focus();
        }
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace' && !input.value && index > 0) {
          inputs[index - 1].focus();
        }
      });
    }); 
 })
 useEffect(() => {
    let timer;
    if (resendDisabled && seconds > 0) {
      timer = setInterval(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
    } else if (seconds === 0) {
      setResendDisabled(false);
    }

    return () => clearInterval(timer);
  }, [seconds, resendDisabled]);
 
    return (
        <>
            <div>
                <Modal className="success-modal" show={showmobile} >
                    <div>
                        <Modal.Body className="textsucess">Your mobile number {resp_mob_no} is registered with email id provided.
                            Clicking on update will proceed further.
                        </Modal.Body>
                        <div className="closeupdate">
                            <div className="closebtn"> <button className="btnClose" onClick={handleClosePopup}>Close</button></div>
                            <div className="update"> <button className="btnClose" onClick={updateMobile}>Update</button></div>
                        </div>
                    </div>

                </Modal>
                <Container>
                    <Modal show={modelshow} onHide={handleClose} backdrop="static" keyboard={false}>
                    {/* <Modal show={false} onHide={handleClose} backdrop="static" keyboard={false}> */}
                        <Modal.Body>
                        <div className="loginsignupnew_popup">
                            <div className="loginsignupnew_popupleft">
                                
                                {/* alt="Logo" */}
                                <img src={LogoWhite} alt="Logo"></img>
                            <div className="loginsignupnewpopup_slider">
                            <Slider {...settings}>
                                <div className="loginsignupnewpopup_slideritem">
                                       <span>Simple, <strong>FREE</strong> Investment</span>
                                </div>
                                <div className="loginsignupnewpopup_slideritem">
                                       <span><i><FaRupeeSign className="FaRupeeSign" /></i>
                                       <strong className="lgnsgnupnewpopup_10rup">10</strong> 
                                       <br></br><small>Per </small>Order</span>
                                </div>
                                <div className="loginsignupnewpopup_slideritem">
                                       <span><strong>0</strong> AMC for <br></br>First Year</span>
                                </div>
                                <div className="loginsignupnewpopup_slideritem">
                                       <span><strong>FREE</strong> Account <br></br>Opening</span>
                                </div>
                                <div className="loginsignupnewpopup_slideritem">
                                       <span><strong>FREE</strong> Algo <br></br>Trading</span>
                                </div>
                                </Slider>
                            </div>
                            </div>
                          <div className="loginsignupnew_popupright">
                          <span className="closeBtn" onClick={handleClose}>
                                    <img className="cursortype" src={closeIcon} alt="close-icon" />
                                </span>
                             <h1>Welcome to <span>Moneysukh</span> </h1>
                             <form className="loginsignupnew_form">
                                <div className={`form-group ${newmobotpverify==true?'d-none':''}`}>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                        <span class="input-group-text"><FaUser className="Fauser" /></span>
                                        </div>
                                        <input type="text" class="form-control" placeholder="Enter Your Name" onChange={(e)=>setNameUser(e.target.value)} autocomplete="off"/>
                                    </div>
                                </div>
                                 <div className={`form-group ${newmobotpverify==true?'d-none':''}`}>
                                <div class="input-group">
                                        <div class="input-group-prepend">
                                        <span class="input-group-text"><FaPhone className="FaPhone" /></span>
                                        </div>
                                        {/* <input type="number" class="form-control" placeholder="Enter Your Mobile No." autocomplete="off"/> */}
                                        <input type="text" class="form-control" placeholder="Enter Your Mobile Number" name="mob_no" onChange={handleNewUserMobileNumber} value={mob_no} max={10} autoComplete="off" />
                                            {newUserMoberror != '' && <div className="errormsgmobile">{newUserMoberror}</div>}
                                    </div>
                                </div>
                                <div class={`inputctaopt_grid ${newmobotpverify==false?'d-none':''}`}>
                                    <h5>Enter your OTP sent your Registered Mobile No. </h5>
                                        <div class="input-group">
                                            {/* <div class="input-group-prepend">
                                                <div class="input-group-text">{eyenew ? (<FaEye />) : <FaEyeSlash className="faeyeslash" />}</div>
                                            </div> */}
                                            <div class="inputctaopt_group form-control">
                                                <div className="inputctaopt"> <input size="1" type="password" class="form-control" onChange={(e)=>setotpis1(e.target.value)} value={otpis1} id="otp1" maxlength="1" autocomplete="off"/></div>
                                                <div className="inputctaopt"> <input size="1" type="password" class="form-control" onChange={(e)=>setotpis2(e.target.value)} value={otpis2} id="otp2" maxlength="1" autocomplete="off"/></div>
                                                <div className="inputctaopt"> <input size="1" type="password" class="form-control" onChange={(e)=>setotpis3(e.target.value)} value={otpis3} id="otp3" maxlength="1" autocomplete="off"/></div>
                                                  <div className="inputctaopt"> <input size="1" type="password" class="form-control" onChange={(e)=>setotpis4(e.target.value)} value={otpis4} id="otp4" maxlength="1" autocomplete="off"/></div>
                                            </div>
                                        </div>
                                        <h6 className="otprecvresend_text">{resendDisabled ?  <span>OTP will expire in <strong>{seconds} Sec</strong>.</span> :  <span>Didn’t received? <span onClick={loginwithemailnewflow} className="resent_otp">Resend OTP</span></span>}</h6>
                                 </div>
                                <div class="form-group">
                                {/* <button type="submit" class="btn btn-primary w-100">Continue</button> */}
                               {newmobotpverify==true ?verifyloader==true?<button type="button" class="btn btn-primary w-100">Wait..</button>:<button type="button" class="btn btn-primary w-100" onClick={(e)=>NewsignFlow(e)}>Verify</button>: <button type="button" class="btn btn-primary w-100" onClick={() => loginwithemailnewflow()}>Continue</button>}
                                </div>
                            </form>
                            <p>By continuing, i accept the Terms & Conditions 
                            and agree to receive updates on Whatsapp.</p>
                          </div>
                          </div>
                            <div class="sign-left d-none">Simple, Free  Investment</div>
                            <div className="sign-in-main d-none">
                                <span className="closeBtn" onClick={handleClose}>
                                    <img className="cursortype" src={closeIcon} alt="close-icon" />
                                </span>
                                <h1>
                                    Welcome to <span>Moneysukh</span>
                                </h1>
                                {isGoogleLoginOpened && (<div>
                                    <div className="input-block nomargin label">
                                        <label className="labelheading paddingleft15" onClick={ValidateMobileNumber}>Enter Your Mobile Number : </label>
                                    </div>
                                    <div className="input-block nomargin">
                                        <div className="passtextboxnew1mobile">
                                            <input type="text" placeholder="Enter Your Mobile Number" name="mob_no" onChange={handleNewUserMobileNumber} value={mob_no} max={10} autoComplete="off" />
                                            {newUserMoberror != '' && <div className="errormsgmobile">{newUserMoberror}</div>}

                                        </div>

                                    </div>
                                    <div>
                                        <div className="Div-Block">
                                            <div>

                                                {(mob_no == "") || (mobile_l <= 9) ?
                                                    <div className="div2">
                                                        {/* <div onClick={mobileerror} title="Click to Sign In with your Google account" className="absolute-center ContinueGoogleBtn">

                                                            <img className="" src={googleImg} alt="Gmail Logo" width="25" height="25"></img>
                                                            <div className="text-google-contin">Continue with Google</div>
                                                        </div> */}
                                                    </div>

                                                    :

                                                    <div className="divwidth">
                                                        {/* <div title="Click to Sign In with your Google account" className="absolute-center ContinueGoogleBtn">
                                                            <div className="ButtonIFrame" id="signInDiv" ref={divRef}>
                                                            </div>

                                                            <img className="" src={googleImg} alt="Gmail Logo" width="25" height="25"></img>
                                                            <div className="text-google-contin">Continue with Google</div>
                                                        </div> */}
                                                    </div>}

                                                {/* <div ref={divRef} id="signInDiv"></div> */}



                                                {loadingshowgoogle ? <div className="textcenter">
                                                    <Vortex
                                                        visible={true}
                                                        height="80"
                                                        width="80"
                                                        ariaLabel="vortex-loading"
                                                        wrapperStyle={{}}
                                                        wrapperClass="vortex-wrapper"
                                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                    />
                                                    <div className="model_popup">Please Wait...</div>
                                                </div> : ""
                                                }
                                            </div>

                                            <div className="separation-line">
                                                <span>Or</span>
                                            </div>
                                            {/* <div className="input-block-pop">
                                                <input type="email" placeholder="Your Email Address" name="email" onChange={handleChange} value={email} autoComplete="off" />
                                                {emailerror != '' && <div className="errormsg">{emailerror}</div>}

                                            </div> */}
                                            <div className="input-block-pop">
                                              <span>QR Code</span>

                                            </div>

                                            <div className="input-block paddingtop10">
                                                {(mob_no == "") || (mobile_l <= 9) ?
                                                    <button type="button" onClick={() => loginwithemail()}>Continue</button> :
                                                    <button type="button" onClick={() => loginwithemail()}>Continue</button>}

                                            </div>
                                        </div>
                                        <p className="logpop">
                                            By proceeding, I agree to <span> <a target="_blank" href="../TermsCondition">T&C </a> </span>,
                                            <span> <a target="_blank" href="../PrivacyPolicy">Privacy Policy </a></span>
                                        </p>
                                    </div>

                                </div>
                                )}
                                {isuseridpassword && (<div>
                                    <div className="input-block">
                                        <label className="labelheading">Your Email Address </label>
                                    </div>
                                    <div className="input-block">
                                        <label className="Loginlabel">{email}</label>
                                    </div>
                                    <div className="input-block">
                                        <label className="labelheading">Enter Password </label>
                                    </div>
                                    <div className="input-block">
                                        <div className="passtextboxnew">
                                            <input type={passwordnewtype} placeholder="Enter Password" name="password" onChange={handleChangepassword} value={password} autoComplete="off" />
                                        </div>
                                        <div onClick={funEyenew} className="eyefab"> {eyenew ? (<FaEye />) : <FaEyeSlash className="faeyeslash" />} </div>
                                        {passworderror != '' && <div className="errormsgmobile">{passworderror}</div>}

                                        <div className="forgotpassword" >
                                            <span onClick={() => functionforgotpassword()}>Generate Password</span>
                                        </div>
                                    </div>

                                    <div className="input-block paddingtop10">
                                        <button type="button" onClick={() => loginwithpassword()}>Submit</button>
                                    </div>
                                </div>
                                )}
                                {isForgotdiv && (<div>
                                    <div className="input-block">
                                        <label className="labelheading">Your Email Address </label>
                                    </div>
                                    <div className="input-block">
                                        <input type="email" placeholder="Your Email Address" name="email" onChange={handleChange} value={email} autoComplete="off" />
                                        {emailerror != '' && <div className="errormsgmobile">{emailerror}</div>}
                                    </div>
                                    <div className="input-block paddingtop10">
                                        <button type="button" onClick={() => OTPsend()}>Send OTP</button>
                                    </div>
                                </div>
                                )}
                                {newmobotpverify && (<div>
                                    <div className="input-block">
                                        <label className="labelheading">Your Mobile Number </label>
                                    </div>
                                    <div className="input-block">
                                        <label className="Loginlabel">{mob_no}</label>
                                    </div>
                                    <div className="input-block">
                                        <label className="labelheading">Enter OTP</label>
                                    </div>
                                    <div className="input-block">
                                        <input type="number" placeholder="Enter OTP" name="otpnew" onChange={handleChangeOTPNew} value={otpnew} autoComplete="off" />
                                        {otperror != '' && <div className="errormsg">{otperror}</div>}
                                    </div>
                                    <div className="input-block paddingtop10">
                                        <button type="button" onClick={(e)=>NewsignFlow(e)}>Verify Otp</button>
                                    </div>
                                </div>
                                )}
                                {isOTPdiv && (<div>
                                    <div className="input-block">
                                        <label className="labelheading">Your Email Address </label>
                                    </div>
                                    <div className="input-block">
                                        <label className="Loginlabel">{email}</label>
                                    </div>
                                    <div className="input-block">
                                        <label className="labelheading">Enter OTP</label>
                                    </div>
                                    <div className="input-block">
                                        <input type="number" placeholder="Enter OTP" name="otp" onChange={handleChangeOTP} value={otp} autoComplete="off" />
                                        {otperror != '' && <div className="errormsg">{otperror}</div>}
                                    </div>
                                    <div className="input-block paddingtop10">
                                        <button type="button" onClick={() => changepassword()}>Change Password</button>
                                    </div>
                                </div>
                                )}
                                {isnewpassword && (<div>
                                    <div className="input-block">
                                        <label className="labelheading">Enter New Password </label>
                                    </div>
                                    <div className="input-block">
                                        <div className="passtextboxnew">
                                            <input type={passwordtype} placeholder="Enter your password" value={newpassword} onChange={handlenewChangepassword} name="password" autoComplete="off" />
                                        </div>
                                        <div onClick={funEye} className="eyefab"> {eye ? (<FaEye />) : <FaEyeSlash className="faeyeslash" />} </div>
                                        {newpassworderror != '' && <div className="errormsg">{newpassworderror}</div>}
                                    </div>
                                    <div className="input-block">
                                        <label className="labelheading">Confirm New Password </label>
                                    </div>
                                    <div className="input-block">
                                        <div className="passtextboxnew">
                                            <input type={confrimpasswordtype} placeholder="Enter Confirm Password" name="confirmnewpassword" onChange={handleconfirmnewpassword} value={confirmnewpassword} autoComplete="off" />

                                        </div>
                                        <div onClick={funconfirmEye} className="eyefab">{confirmeye ? (<FaEye />) : <FaEyeSlash className="faeyeslash" />} </div>
                                        {confirmnewpassworderror != '' && <div className="errormsg">{confirmnewpassworderror}</div>}
                                    </div>
                                    <div className="input-block">
                                        {commonnewpassworderror != '' && <div className="errormsg">{commonnewpassworderror}</div>}
                                    </div>
                                    <div className="messageppop">
                                        Password must be at least 8 characters. It must contain one Upper case alphabet & numbers without spaces.

                                    </div>
                                    <div className="input-block paddingtop10">
                                        <button type="button" onClick={() => updatepassword()}>Update Password</button>
                                    </div>
                                </div>
                                )}
                                {isusername && (<div >
                                    <div className="input-block nomargin">
                                        <label className="labelheading logpaddingleft15">Enter First Name </label>
                                    </div>
                                    <div className="input-block nomargin">
                                        <div className="passtextboxnew1">
                                            <input type="text" placeholder="Enter First Name" value={newuserfirstname} onChange={handlenewusername} name="newuserfirstname" autoComplete="off" />
                                        </div>
                                        {newuserfirstnameerror != '' && <div className="errormsg1">{newuserfirstnameerror}</div>}
                                    </div>
                                    <div className="input-block nomargin">
                                        <label className="labelheading logpaddingleft15">Enter Last Name </label>
                                    </div>
                                    <div className="input-block nomargin">
                                        <div className="passtextboxnew1">
                                            <input type="text" placeholder="Enter Last Name" name="newuserlastname" onChange={handlenewuserlastname} value={newuserlastname} autoComplete="off" />
                                        </div>
                                        {newuserlastnameerror != '' && <div className="errormsg1">{newuserlastnameerror}</div>}
                                    </div>
                                    {/* <div>
                                        <div className="input-block nomargin label">
                                            <label className="labelheading paddingleft15">Enter Your Mobile Number : </label>
                                        </div>
                                        <div className="input-block nomargin">
                                            <div className="passtextboxnew1">
                                                <input type="text" placeholder="Enter Your Mobile Number" name="mob_no" onChange={handleNewUserMobileNumberNew} value={mob_no} autoComplete="off" />
                                                {newUserMoberror != '' && <div className="errormsg">{newUserMoberror}</div>}
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="divheight30"></div>

                                    {/* <div className="input-block">
                                        <button type="button" onClick={() => updatefirstlastname()}>Update</button>
                          
                                    </div> */}
                                    {loadingshow ?
                                        <><div className="input-block_disable">
                                            <button type="button" disabled>Update</button>

                                        </div><div className="textcenter">
                                                <Vortex
                                                    visible={true}
                                                    height="80"
                                                    width="80"
                                                    ariaLabel="vortex-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClass="vortex-wrapper"
                                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                />
                                                <div className="model_popup">loading data..</div>

                                            </div></> : <div className="input-block">
                                            <button type="button" onClick={() => updatefirstlastname()}>Update</button>

                                        </div>
                                    }
                                </div>
                                )}
                                {isthankyou && (<div>
                                    <div className="input-block">
                                        <label className="labelheading">Thank you for Registration.</label>
                                        <label className="labelheading">
                                            Please <a className="link" onClick={routeChange}>Login</a> with your email and password.
                                        </label>
                                    </div>
                                </div>
                                )}

                            </div>

                        </Modal.Body>
                    </Modal>
                </Container>
            </div>
        </>
    );
}
export default React.forwardRef(LoginPopup);





// -----------------------------------------new signup ui 01-01-2024 start code -----------------------------------------

// import React, {
//     useState,
//     useEffect,
//     useImperativeHandle,
//     useContext,
//     useRef,
//   } from "react";
//   import { Container, Row, Col, Modal, Button } from "react-bootstrap";
//   import axios from "axios";
//   import { useNavigate } from "react-router-dom";
//   import googleImg from "./../../../Images/google-img.png";
//   import closeIcon from "./../../../Images/close-icon.png";
//   import { useSelector, useDispatch } from "react-redux";
//   import {
//     userSelector,
//     clearState,
//     signupUser,
//     forgotpassword,
//     checkvalidotp,
//     userupdatepassword,
//     userupdateusername,
//     signinemailpassword,
//     ValidateMobile,
//   } from "../../features/User/UserSlice";
//   import { gapi } from "gapi-script";
//   import { GoogleLogin } from "react-google-login";
//   import URLstateContext from "../../../provider/CommonContext";
//   import "./Loginpopup.css";
//   import { FaEye, FaEyeSlash } from "react-icons/fa";
//   import sha256 from "crypto-js/sha256";
//   import { Vortex } from "react-loader-spinner";
//   import jwt_decode from "jwt-decode";
//   import { decode as base64_decode, encode as base64_encode } from "base-64";
//   import whatsappQrimg from "./img/whatsappQr.png";
//   import TrackApi from "../../Activity_Track/TrackApi";
// import { Apiurl } from "../../Configuration/configuration";
// import { useCookies } from "react-cookie";
  
//   function LoginPopup(props, ref) {
//     const { clientId } = useContext(URLstateContext);
//     const [modelshow, setShow] = useState(false);
//     const handleClose = () => {
//       setShow(false);
//       setNewUserMobNo("");
//       setNewUserMoberror("");
//       setemailerror("");
//       setemail("");
//     };
//     const [email, setemail] = useState("");
//     const [emailerror, setemailerror] = useState("");
//     const [otperror, setotperror] = useState("");
//     const dispatch = useDispatch();
//     const [password, setpassword] = useState("");
//     const [passworderror, setpassworderror] = useState("");
//     const [isGoogleLoginOpened, setisGoogleLoginOpened] = useState(true);
//     const [isForgotdiv, setisForgotdiv] = useState(false);
//     const [otp, setotp] = useState("");
//     const [isOTPdiv, setisOTPdiv] = useState(false);
//     const [isuseridpassword, setisuseridpassword] = useState(false);
//     const [isnewpassword, setisnewpassword] = useState(false);
//     const [mobile_l, setMobile_l] = useState("");
//     const [newpassword, setnewpassword] = useState("");
//     const [newpassworderror, setnewpassworderror] = useState("");
//     const [passwordtype, setpasswordtype] = useState("password");
//     const [confrimpasswordtype, setconfrimpasswordtype] = useState("password");
//     const [loadingshow, setloadingshow] = useState(false);
//     const [showmobile, setshowmobile] = useState(false);
//     const [loadingshowgoogle, setloadingshowgoogle] = useState(false);
  
//     const [confirmnewpassword, setconfirmnewpassword] = useState("");
//     const [confirmnewpassworderror, setconfirmnewpassworderror] = useState("");
//     const [commonnewpassworderror, setcommonnewpassworderror] = useState("");
//     const [eye, seteye] = useState(true);
//     const [confirmeye, setconfirmeye] = useState(true);
//     //User Firstname and Lastname
//     const [isusername, setissusername] = useState(false);
//     const [newuserfirstname, setnewuserfirstname] = useState("");
//     const [nameUrl, setNameUrl] = useState("");
//     const [nameNew, setNameNew] = useState("");
//     const [userfirstnameError, setUserfirstnameError] = useState("");
//     const [newuserlastname, setnewuserlastname] = useState("");
//     const [mob_no, setNewUserMobNo] = useState([]);
//     const [resp_mob_no, setRespNewUserMobNo] = useState([]);
//     const [resp_mob_no_update, setRespNewUserMobNoupdate] = useState([]);
//     const [disabledmobile, setdisabledmobile] = useState(true);
//     const [newuserfirstnameerror, setnewuserfirstnameerror] = useState("");
//     const [newuserlastnameerror, setnewuserlastnameerror] = useState("");
//     const [newUserMoberror, setNewUserMoberror] = useState("");
  
//     const [isthankyou, setisthankyou] = useState(false);
//     const [eyenew, setneweye] = useState(true);
//     const [passwordnewtype, setpasswordnewtype] = useState("password");
//     const { CRMBaseURL } = useContext(URLstateContext);
//     const [isDisabled, setIsDisabled] = useState(false);
//     const divRef = useRef(null);
  
//     const [user, setUser] = useState([]);
//     const [cookies, setCookie] = useCookies(['LeadId']);
  
//     // const fetchData = () => {
//     //   return fetch("../../api/Login/ValidateMobile")
//     //         // .then((response) => response.json())
//     //         .then((data) => setUser(data));
//     // }
  
//     let navigate = useNavigate();
//     useImperativeHandle(ref, () => ({
//       changeTogglePopup: (hideshow) => {
//         setisGoogleLoginOpened(true);
//         setisuseridpassword(false);
//         setissusername(false);
//         setconfirmnewpassword(false);
//         setisOTPdiv(false);
//         setisnewpassword(false);
//         setisthankyou(false);
//         setisForgotdiv(false);
//         setpassworderror("");
//         setShow(hideshow);
//       },
//     }));
  
//     const usrname = useSelector((state) => state.user.email);
//     const {
//       flg_mobValidated,
//       isFetching,
//       isSuccess,
//       isError,
//       errorMessage,
//       isforgot,
//       isotpflag,
//       isnewpassflag,
//       isupdflag,
//       isusernameflag,
//       isCRMuser,
//     } = useSelector(userSelector);
  
//     function handleCredentialResponse(response) {
//       // console.log("response:" + JSON.stringify(response.credential));
//       var userobj = jwt_decode(response.credential);
//       // console.log(userobj);
//       onSuccess(userobj);
//     }
  
//     useEffect(() => {
//       /* global google */
  
//       if (divRef.current) {
//         google.accounts.id.initialize({
//           client_id: clientId,
//           callback: handleCredentialResponse,
//         });
//         google.accounts.id.renderButton(document.getElementById("signInDiv"), {
//           type: "standard",
//           theme: "outline",
//           size: "large",
//           shape: "rectangular",
//           width: "100%",
//           logo_alignment: "left",
//         });
//         google.accounts.id.prompt();
//       }
//     });
  
//     const onSuccess = (res) => {
//       var websiteurl = window.location.href;
//       //console.log("res: " + res)
  
//       alert(`Logged in successfully welcome ${res.name} 😍.`);
//       setloadingshowgoogle(true);
//       var data = {
//         name: res.name,
//         email: res.email,
//         googleid: res.jti,
//         tokenid: res.jti,
//         accesstoken: res.jti,
//         imgurl: res.picture,
//         familyname: res.family_name,
//         givenName: res.given_name,
//         nameNew: res.name,
//         mob_no: mob_no,
//         websiteurl: websiteurl,
//       };
//       //console.log("data:" + JSON.stringify(data));
// //  lead creat api
//       let bodydataleadapi=[
//         {
//         "Attribute": "EmailAddress",
//         "Value": res.email
//         },{
//           "Attribute": "Phone",
//           "Value": ""
//           },{
//             "Attribute": "mx_Primary_Email_ID",
//             "Value":res.email
//             },{
//               "Attribute": "SearchBy",
//               "Value":"mx_Primary_Email_ID"
//               },];
      
//       axios
//       .post("https://api-in21.leadsquared.com/v2/LeadManagement.svc/Lead.CreateOrUpdate?postUpdatedLead=false&accessKey=eee&secretKey=eee", bodydataleadapi).then(async(responelead)=>{
//         console.log("uhhhhhh",responelead.data.Message);
//        const leadId=await responelead.data.Message && responelead.data.Message.Id;
//        setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
//        const payloadData={
//         "RelatedProspectId":leadId,
//         "ActivityNote": "Your Activity Note",
//         "mx_Custom_1": "Sign Up",
//         "mx_Custom_2": "Your Activity Note",
//         "mx_CustomObject_81":window.location.href
//        }
//        TrackApi(payloadData);
//       })
// //  lead api end code 

//       setloadingshowgoogle(true);
  

//       dispatch(signupUser(data));
//     };
  
//     useEffect(() => {
//       if (isSuccess) {
//         //console.log("isCRMuser" + isCRMuser);
//         setShow(false);
//         setloadingshowgoogle(false);
//       }
  
//       if (isforgot) {
//         //console.log("Raviuday");
//       }
  
//       if (isError) {
//         setpassworderror("Invalid userid and password");
//         //console.log(errorMessage);
//         dispatch(clearState());
//       }
//     }, [isSuccess, isError, isforgot]);
  
//     const ValidateMobileNumber = () => {};
  
//     const onFailure = (err) => {
//       // console.log('failed:', err);
//     };
//     const onLogoutSuccess = (res) => {
//       //console.log('Logged out Successfully:', res);
//       localStorage.removeItem("token");
  
//       alert("Logged out Successfully ✌");
//       window.location.reload();
//     };
  
//     useEffect(() => {
//       if (isotpflag) {
//         //console.log("Raviuday");
//         setisOTPdiv(false);
//         setisnewpassword(true);
//       } else {
//         setotperror("Please enter valid OTP");
//       }
//     }, [isotpflag]);
  
//     useEffect(() => {
//       if (isupdflag) {
//         if (isnewpassflag) {
//           setisnewpassword(false);
//           setissusername(true);
//         } else {
//           setloadingshow(false);
//           setisnewpassword(false);
//           setisthankyou(true);
//           setIsDisabled(false);
//         }
//       }
//     }, [isnewpassflag, isupdflag]);
  
//     useEffect(() => {
//       if (isusernameflag) {
//         setIsDisabled(false);
//         setloadingshow(false);
//         setissusername(false);
//         setisthankyou(true);
//       }
//     }, [isusernameflag]);
  
//     // const loginwithMobile = () => {
  
//     //     if (newUserMobNo == "") {
//     //         setNewUserMoberror("Please Enter Mobile Number");
//     //         return false;
//     //     }
//     // }
//     const handleClosePopup = () => {
//       setshowmobile(false);
//     };
  
//     const [post, updatePost] = useState({ mob_no: "" });
//     const SignUpNew=()=>{
//       let re =
//       /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//       if (email == "") {
//         setemailerror("Please enter email address");
//         return false;
//       }
//       if (re.test(email)) {
//         // lead creat api
//         let bodydataleadapi=[
//           {
//           "Attribute": "EmailAddress",
//           "Value":email
//           },{
//             "Attribute": "Phone",
//             "Value": ""
//             },{
//               "Attribute": "mx_Primary_Email_ID",
//               "Value":email
//               },{
//                 "Attribute": "SearchBy",
//                 "Value":"mx_Primary_Email_ID"
//                 },];
        
//         axios
//         .post("https://api-in21.leadsquared.com/v2/LeadManagement.svc/Lead.CreateOrUpdate?postUpdatedLead=false&accessKey=eeee&secretKey=eeee", bodydataleadapi).then(async(responelead)=>{
//           console.log("uhhhhhh",responelead.data.Message);
//          const leadId=await responelead.data.Message && responelead.data.Message.Id;
//          setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
//          const payloadData={
//           "RelatedProspectId":leadId,
//           "ActivityNote": "Your Activity Note",
//           "mx_Custom_1": "Sign Up",
//           "mx_Custom_2": "Your Activity Note",
//           "mx_CustomObject_81":window.location.href
//          }
//          TrackApi(payloadData);
//         })
//   //  lead api end code 
//         window.open(`https://online.moneysukh.com/signup?email=${email}`, '_blank')
//       }else{
//         setemailerror("Please enter valid email");
//       }
//     }
//     const loginwithemail = () => {
      
//       let re =
//         /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
//       if (email == "") {
//         setemailerror("Please enter email address");
//         return false;
//       }
  
//       if (mob_no != "" && mob_no.toString().length === 10) {
//         if (re.test(email)) {
          
//           axios
//             .post(`${Apiurl}/api/Login/ValidateMobile`, { email: email, mob_no: mob_no })
//             .then(function (response) {
//               if (response.data.success === true) {
//                 if (response.data.data.mob_no == mob_no) {
//                   setisGoogleLoginOpened(false);
//                   setisuseridpassword(true);
//                   return false;
//                 }
//                 if (mobile_l >= 9) {
//                   setshowmobile(true);
//                 }
//                 setRespNewUserMobNoupdate(response.data.data.mob_no);
//                 var str = response.data.data.mob_no;
//                 var replaced = str.replace(/.(?=.{4,}$)/g, "*");
//                 setRespNewUserMobNo(replaced);
//               } else {
//                 setshowmobile(false);
// //  lead creat api
// // let bodydataleadapi=[
// //     {
// //     "Attribute": "EmailAddress",
// //     "Value": email
// //     },{
// //       "Attribute": "Phone",
// //       "Value": mob_no
// //       },{
// //         "Attribute": "mx_Primary_Email_ID",
// //         "Value":email
// //         },{
// //           "Attribute": "SearchBy",
// //           "Value":"mx_Primary_Email_ID"
// //           },];
  
// //   axios
// //   .post("https://api-in21.leadsquared.com/v2/LeadManagement.svc/Lead.CreateOrUpdate?postUpdatedLead=false&accessKey=eee&secretKey=eeee", bodydataleadapi).then(async(responelead)=>{
// //     console.log("uhhhhhh",responelead.data.Message);
// //    const leadId=await responelead.data.Message && responelead.data.Message.Id;
// //    setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
// //    const payloadData={
// //     "RelatedProspectId":leadId,
// //     "ActivityNote": "Your Activity Note",
// //     "mx_Custom_1": "Sign Up",
// //     "mx_Custom_2": "Your Activity Note",
// //     "mx_CustomObject_81":window.location.href
// //    }
// //    TrackApi(payloadData);
// //   })
// // lead creat api end code
  
  
//                 axios
//                   .post(`${Apiurl}/api/Login/UpdateMobile`, {
//                     email: email,
//                     mob_no: mob_no,
//                   })
//                   .then(function (response) {
//                     if (response.data.success === true) {
//                       setisGoogleLoginOpened(false);
//                       setisuseridpassword(true);
//                       setshowmobile(false);
//                       return true;
//                     }
//                   });
//                 setemailerror("Please enter valid email address");
//               }
//             })
//             .catch(function (response) {});
//         } else {
//           setemailerror("Please enter valid email address");
//           return false;
//         }
//       } else {
//         setNewUserMoberror("Please enter valid mobile number");
//         return false;
//       }
  
//       const reMob = /^[0-9\b]+$/;
//       // if (mob_no == "") {
//       //     setNewUserMoberror("Please enter valid mobile number");
//       //     return false;
//       // }
//       // else {
//       //     setNewUserMoberror("Please enter valid mobile number");
//       //     return false;
//       // }
//     };
//     const mobileerror = (event) => {
//       const re = /^[0-9\b]+$/;
//       if (mob_no == "") {
//         setNewUserMoberror("Please enter valid mobile number");
//         return false;
//       } else {
//         setNewUserMoberror("Please enter valid mobile number");
//         return false;
//       }
//     };
//     const updateMobile = () => {
//       axios
//         .post("/api/Login/UpdateMobile", { email: email, mob_no: mob_no })
//         .then(function (response) {
//           if (response.data.success === true) {
//             // handleShow("");
//             // alert("Data not submitted!!! Please Try Again")
//             setisGoogleLoginOpened(false);
//             setisuseridpassword(true);
//             setshowmobile(false);
//             return true;
//           } else {
//             // alert("Data not submitted!!! Please Try Again")
//             // setisuseridpassword(true);
//           }
//         })
//         .catch(function (response) {});
//     };
//     const handleNewUserMobileNumber = (event) => {
//       // if(event.target.value.length  == "" && event.target.value.length <= 10 ){
//       //     document.getElementById('error').style.display ="block";
//       // }
//       // else{
//       //     document.getElementById('error').style.display ="none";
//       // }
//       const re = /^[0-9\b]+$/;
//       setMobile_l(event.target.value.length);
//       if (event.target.value.length <= 10 && re.test(event.target.value)) {
//         setNewUserMobNo(parseInt(event.target.value));
//       }
  
//       if (event.target.value.length == 0) {
//         setNewUserMobNo("");
//       }
//       setNewUserMoberror("");
//     };
  
//     const handleUsername = (event) => {
//       const re = /^[A-Za-z\s]*$/;
//       if (event.target.value === "" || re.test(event.target.value)) {
//         setNameNew(event.target.value);
//       }
//       setUserfirstnameError("");
//     };
  
//     const loginsubmit = () => {};
//     const handleChange = (event) => {
//       setemail(event.target.value);
//       setemailerror("");
//     };
//     const handleChangepassword = (event) => {
//       setpassword(event.target.value);
//       setpassworderror("");
//     };
//     const loginwithpassword = () => {
//       if (password == "") {
//         setpassworderror("Please enter password");
//         return false;
//       }
//       var passencrypted = base64_encode(password);
  
//       var data = {
//         email: email,
//         password: passencrypted,
//       };
//       dispatch(signinemailpassword(data));
//     };
//     const OTPsend = () => {
//       var data = {
//         email: email,
//         mob_no: mob_no,
//       };
//       dispatch(forgotpassword(data));
//       setisForgotdiv(false);
//       setisOTPdiv(true);
//     };
//     const functionforgotpassword = () => {
//       setisuseridpassword(false);
//       setisForgotdiv(true);
//     };
//     const handleChangeOTP = (event) => {
//       setotp(event.target.value);
//     };
//     const changepassword = () => {
//       //console.log("otp:" + otp);
//       if (otp == "") {
//         setotperror("Please enter OTP");
//         return false;
//       } else {
//         var data = {
//           email: email,
//           otp: otp,
//         };
//         dispatch(checkvalidotp(data));
//       }
//     };
//     const handlenewChangepassword = (event) => {
//       setnewpassword(event.target.value);
//       setnewpassworderror("");
//     };
//     const handleconfirmnewpassword = (event) => {
//       setconfirmnewpassword(event.target.value);
//       setconfirmnewpassworderror("");
//     };
//     const updatepassword = (event) => {
//       var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  
//       if (newpassword == "") {
//         setnewpassworderror("Please enter new password");
//         return false;
//       }
//       if (re.test(newpassword)) {
//       } else {
//         setnewpassworderror("Please enter valid password");
//         return false;
//       }
//       if (confirmnewpassword == "") {
//         setconfirmnewpassworderror("Please enter new confirm password");
//         return false;
//       }
  
//       if (re.test(confirmnewpassword)) {
//         //setnewpassworderror("Password valid");
//       } else {
//         setconfirmnewpassworderror("Please enter valid password");
//         return false;
//       }
//       if (newpassword != confirmnewpassword) {
//         setcommonnewpassworderror(
//           "Both Password and Confirm Password must be same."
//         );
//         return false;
//       }
  
//       var passencrypted = base64_encode(newpassword);
  
//       var data = {
//         email: email,
//         password: passencrypted,
//       };
//       dispatch(userupdatepassword(data));
//     };
//     const funEye = () => {
//       if (passwordtype == "password") {
//         setpasswordtype("text");
//         seteye(false);
//       } else {
//         setpasswordtype("password");
//         seteye(true);
//       }
//     };
//     const funconfirmEye = () => {
//       if (confrimpasswordtype == "password") {
//         setconfrimpasswordtype("text");
//         setconfirmeye(false);
//       } else {
//         setconfrimpasswordtype("password");
//         setconfirmeye(true);
//       }
//     };
//     const routeChange = () => {
//       window.location.reload();
//     };
//     const handlenewusername = (event) => {
//       const re = /^[A-Za-z]+$/;
//       const { value } = event.target;
//       if (value === "" || re.test(value)) {
//         setnewuserfirstname(value);
//       }
//       //setnewuserfirstname(event.target.value);
//       setnewuserfirstnameerror("");
//     };
//     const handlenewuserlastname = (event) => {
//       const re = /^[A-Za-z]+$/;
//       const { value } = event.target;
//       if (value === "" || re.test(value)) {
//         setnewuserlastname(value);
//       }
//       setnewuserlastnameerror("");
//     };
  
//     const handleNewUserMobileNumberNew = (event) => {
//       const re = /^[0-9\b]+$/;
//       if (event.target.value.length <= 10 && re.test(event.target.value)) {
//         setNewUserMobNo(parseInt(event.target.value));
//       }
//       setMobile_l(event.target.value.length);
//       if (event.target.value.length == 0) {
//         setNewUserMobNo("");
//       }
//       setNewUserMoberror("");
//     };
  
//     const updatefirstlastname = (event) => {
//       setIsDisabled(true);
//       var re = /^(?=.*\d)(?=.*[a-z][A-Z]).{8,}$/;
//       var remob = /^[0-9\b]+$/;
  
//       if (newuserfirstname == "") {
//         setnewuserfirstnameerror("Please enter first name");
//         setIsDisabled(false);
//         return false;
//       }
  
//       if (newuserlastname == "") {
//         setnewuserlastnameerror("Please enter last name");
//         setIsDisabled(false);
  
//         return false;
//       }
  
//       if (mobile_l == "" || mobile_l <= 9) {
//         setNewUserMoberror("Please enter Mobile No.");
//         setIsDisabled(false);
  
//         return false;
//       }
  
//       setloadingshow(true);
//       setIsDisabled(true);
//       let userfullname = newuserfirstname + " " + newuserlastname;
//       var websiteurl = window.location.href;
//       var data = {
//         email: email,
//         username: userfullname,
//         mob_no: mob_no,
//         websiteurl: websiteurl,
//       };
  
//       dispatch(userupdateusername(data));
//       setIsDisabled(true);
//     };
  
//     const funEyenew = () => {
//       if (passwordnewtype == "password") {
//         setpasswordnewtype("text");
//         setneweye(false);
//       } else {
//         setpasswordnewtype("password");
//         setneweye(true);
//       }
//     };
  
//     return (
//       <>
//         <div>
//           <Modal className="success-modal" show={showmobile}>
//             <div>
//               <Modal.Body className="textsucess">
//                 Your mobile number {resp_mob_no} is registered with email id
//                 provided. Clicking on update will proceed further.
//               </Modal.Body>
//               <div className="closeupdate">
//                 <div className="closebtn">
//                   {" "}
//                   <button className="btnClose" onClick={handleClosePopup}>
//                     Close
//                   </button>
//                 </div>
//                 <div className="update">
//                   {" "}
//                   <button className="btnClose" onClick={updateMobile}>
//                     Update
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </Modal>
//           <Container>
//             <Modal
//               show={modelshow}
//               onHide={handleClose}
//               backdrop="static"
//               keyboard={false}
//             >
//               <Modal.Body>
//                 <div class="sign-left">Simple, Free Investment</div>
//                 <div className="sign-in-main">
//                   <span className="closeBtn" onClick={handleClose}>
//                     <img
//                       className="cursortype"
//                       src={closeIcon}
//                       alt="close-icon"
//                     />
//                   </span>
//                   <h1>
//                     Welcome to <span>Moneysukh</span>
//                   </h1>
//                    {/* ----------------Login popup start---------------- */}
//                    {isGoogleLoginOpened && (
//                     <div>
//                       <div className="signpopup_formarea">
//                         <div className="">
//                           <div className="row input-block nomargin ">
//                             <div className="col-md-12">
//                               <div className="  passtextboxnew1mobile loginpoup_group hiddencurrent d-none">
//                                 <input
//                                   type="text"
//                                   placeholder="Mobile Number"
//                                   name="mob_no"
//                                   onChange={handleNewUserMobileNumber}
//                                   value={mob_no}
//                                   max={10}
//                                   autoComplete="off"
//                                 />
//                                 {newUserMoberror != "" && (
//                                   <div className="errormsgmobile">
//                                     {newUserMoberror}
//                                   </div>
//                                 )}
//                               </div>
//                               <div className=" input-block-pop loginpoup_group">
//                                 <input
//                                   type="email"
//                                   placeholder="Enter Email Address"
//                                   name="email"
//                                   onChange={handleChange}
//                                   value={email}
//                                   autoComplete="off"
//                                 />
//                                 {emailerror != "" && (
//                                   <div className="errormsg">{emailerror}</div>
//                                 )}
//                               </div>
                              
//                             </div>
//                             <div className="col-md-12">
//                               <div className="">
//                                 <div>
//                                   {/* {mob_no == "" || mobile_l <= 9 ? ( */}
//                                   {false ? (
//                                     <div className="googlelogo">
//                                       <div
//                                         title="Click to Sign In with your Google account"
//                                         className="absolute-center "
//                                       >
//                                         <div className="strdiv"><strong className="">-Or-</strong></div>
//                                         <span
//                                           className="ContinueGoogleBtn"
//                                           onClick={mobileerror}
//                                         >
//                                           <img
//                                             className=""
//                                             src={googleImg}
//                                             alt="Gmail Logo"
//                                             width="25"
//                                             height="25"
//                                           ></img>
//                                           <div className="text-google-contin">
//                                             Google
//                                           </div>
//                                         </span>
//                                       </div>
//                                     </div>
//                                   ) : (
//                                     <div className="divwidth googlelogo">
                                      
//                                       <div
//                                         title="Click to Sign In with your Google account"
//                                       >
//                                       <div className="strdiv">
//                                         <strong>-Or-</strong>
//                                       </div>
//                                        <span className="ContinueGoogleBtn">
//                                        <div
//                                        className="ButtonIFrame"
//                                        id="signInDiv"
//                                        ref={divRef}
//                                      ></div>
  
//                                      <img
//                                        className=""
//                                        src={googleImg}
//                                        alt="Gmail Logo"
//                                        width="25"
//                                        height="25"
//                                      ></img>
//                                      <div className="text-google-contin">
//                                        Google
//                                      </div>
//                                        </span>
//                                       </div>
//                                     </div>
//                                   )}
  
//                                   {loadingshowgoogle ? (
//                                     <div className="textcenter">
//                                       <Vortex
//                                         visible={true}
//                                         height="80"
//                                         width="80"
//                                         ariaLabel="vortex-loading"
//                                         wrapperStyle={{}}
//                                         wrapperClass="vortex-wrapper"
//                                         colors={[
//                                           "#0473ea",
//                                           "#0473ea",
//                                           "#0473ea",
//                                           "#39d800",
//                                           "#39d800",
//                                           "#39d800",
//                                         ]}
//                                       />
//                                       <div className="model_popup">
//                                         Please Wait...
//                                       </div>
//                                     </div>
//                                   ) : (
//                                     ""
//                                   )}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="input-block paddingtop10 pt-0">
//                             {/* //previouse sign up button  */}
//                             {/* {mob_no == "" || mobile_l <= 9 ? (
//                               <button
//                                 type="button"
//                                 onClick={() => loginwithemail()}
//                               >
//                                 Sign Up
//                               </button>
//                             ) : (
//                               <button
//                                 type="button"
//                                 onClick={() => loginwithemail()}
//                               >
//                                 Sign Up
//                               </button>
//                             )} */}
//                             {/* new signup button without mob no only email */}
//                             <button
//                                 type="button"
//                                 onClick={() =>SignUpNew()}
//                               >
//                                 Sign Up
//                               </button>
//                           </div>
//                         </div>
//                         {/*<div>
                                          
//                                           <p className="logpop">
//                                               By proceeding, I agree to <span> <a target="_blank" href="../TermsCondition">T&C </a> </span>,
//                                               <span> <a target="_blank" href="../PrivacyPolicy">Privacy Policy </a></span>
//                                           </p>
//                                               </div>*/}
//                       </div>
//                       <div class="whatsapps_loginarea">
//                         <div class="separation_line">
//                           <span>
//                             <strong>Or</strong>
//                           </span>
//                         </div>
//                         <div class="whatsapps_loginrow">
//                           <div class="row">
//                             <div class="col-sm-8">
//                               <h4>Start your Journey with WhatsApp </h4>
//                               <p>
//                                 Scan the QR code and sign up on your mobile
//                                 device.
//                               </p>
//                             </div>
//                             <div class="col-sm-4">
//                               <div class="whatsapps_qr">
//                                 <img
//                                   src={whatsappQrimg}
//                                   alt="whatsapps"
//                                   class="img-fluid"
//                                 />
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                         <div class="text-center">
//                       <a href="https://wa.link/f3c2hk" class="signupvia_whatsapp">Signup via Whatsapp</a>
//                     </div>
//                       </div>
//                       <div class="logpop_proceeding">
//                         <p>
//                           By proceeding, I agree to{" "}
//                           <span>
//                             {" "}
//                             <a target="_blank" href="../TermsCondition">
//                               T&amp;C
//                             </a>{" "}
//                           </span>
//                           ,
//                           <span>
//                             {" "}
//                             <a target="_blank" href="../PrivacyPolicy">
//                               Privacy Policy{" "}
//                             </a>
//                           </span>
//                         </p>
//                       </div>
//                     </div>
//                   )}
//                  {/* ----------------Login popup End---------------- */}
//                   {isuseridpassword && (
//                     <div>
//                       <div className="input-block">
//                         <label className="labelheading">
//                           Your Email Address{" "}
//                         </label>
//                       </div>
//                       <div className="input-block">
//                         <label className="Loginlabel">{email}</label>
//                       </div>
//                       <div className="input-block">
//                         <label className="labelheading">Enter Password </label>
//                       </div>
//                       <div className="input-block">
//                         <div className="passtextboxnew">
//                           <input
//                             type={passwordnewtype}
//                             placeholder="Enter Password"
//                             name="password"
//                             onChange={handleChangepassword}
//                             value={password}
//                             autoComplete="off"
//                           />
//                         </div>
//                         <div onClick={funEyenew} className="eyefab">
//                           {" "}
//                           {eyenew ? (
//                             <FaEye />
//                           ) : (
//                             <FaEyeSlash className="faeyeslash" />
//                           )}{" "}
//                         </div>
//                         {passworderror != "" && (
//                           <div className="errormsgmobile">{passworderror}</div>
//                         )}
  
//                         <div className="forgotpassword">
//                           <span onClick={() => functionforgotpassword()}>
//                             Generate Password
//                           </span>
//                         </div>
//                       </div>
  
//                       <div className="input-block paddingtop10">
//                         <button type="button" onClick={() => loginwithpassword()}>
//                           Submit
//                         </button>
//                       </div>
//                     </div>
//                   )}
//                   {isForgotdiv && (
//                     <div>
//                       <div className="input-block">
//                         <label className="labelheading">
//                           Your Email Address{" "}
//                         </label>
//                       </div>
//                       <div className="input-block">
//                         <input
//                           type="email"
//                           placeholder="Your Email Address"
//                           name="email"
//                           onChange={handleChange}
//                           value={email}
//                           autoComplete="off"
//                         />
//                         {emailerror != "" && (
//                           <div className="errormsgmobile">{emailerror}</div>
//                         )}
//                       </div>
//                       <div className="input-block paddingtop10">
//                         <button type="button" onClick={() => OTPsend()}>
//                           Send OTP
//                         </button>
//                       </div>
//                     </div>
//                   )}
//                   {isOTPdiv && (
//                     <div>
//                       <div className="input-block">
//                         <label className="labelheading">
//                           Your Email Address{" "}
//                         </label>
//                       </div>
//                       <div className="input-block">
//                         <label className="Loginlabel">{email}</label>
//                       </div>
//                       <div className="input-block">
//                         <label className="labelheading">Enter OTP</label>
//                       </div>
//                       <div className="input-block">
//                         <input
//                           type="number"
//                           placeholder="Enter OTP"
//                           name="otp"
//                           onChange={handleChangeOTP}
//                           value={otp}
//                           autoComplete="off"
//                         />
//                         {otperror != "" && (
//                           <div className="errormsg">{otperror}</div>
//                         )}
//                       </div>
//                       <div className="input-block paddingtop10">
//                         <button type="button" onClick={() => changepassword()}>
//                           Change Password
//                         </button>
//                       </div>
//                     </div>
//                   )}
//                   {isnewpassword && (
//                     <div>
//                       <div className="input-block">
//                         <label className="labelheading">
//                           Enter New Password{" "}
//                         </label>
//                       </div>
//                       <div className="input-block">
//                         <div className="passtextboxnew">
//                           <input
//                             type={passwordtype}
//                             placeholder="Enter your password"
//                             value={newpassword}
//                             onChange={handlenewChangepassword}
//                             name="password"
//                             autoComplete="off"
//                           />
//                         </div>
//                         <div onClick={funEye} className="eyefab">
//                           {" "}
//                           {eye ? (
//                             <FaEye />
//                           ) : (
//                             <FaEyeSlash className="faeyeslash" />
//                           )}{" "}
//                         </div>
//                         {newpassworderror != "" && (
//                           <div className="errormsg">{newpassworderror}</div>
//                         )}
//                       </div>
//                       <div className="input-block">
//                         <label className="labelheading">
//                           Confirm New Password{" "}
//                         </label>
//                       </div>
//                       <div className="input-block">
//                         <div className="passtextboxnew">
//                           <input
//                             type={confrimpasswordtype}
//                             placeholder="Enter Confirm Password"
//                             name="confirmnewpassword"
//                             onChange={handleconfirmnewpassword}
//                             value={confirmnewpassword}
//                             autoComplete="off"
//                           />
//                         </div>
//                         <div onClick={funconfirmEye} className="eyefab">
//                           {confirmeye ? (
//                             <FaEye />
//                           ) : (
//                             <FaEyeSlash className="faeyeslash" />
//                           )}{" "}
//                         </div>
//                         {confirmnewpassworderror != "" && (
//                           <div className="errormsg">
//                             {confirmnewpassworderror}
//                           </div>
//                         )}
//                       </div>
//                       <div className="input-block">
//                         {commonnewpassworderror != "" && (
//                           <div className="errormsg">{commonnewpassworderror}</div>
//                         )}
//                       </div>
//                       <div className="messageppop">
//                         Password must be at least 8 characters. It must contain
//                         one Upper case alphabet & numbers without spaces.
//                       </div>
//                       <div className="input-block paddingtop10">
//                         <button type="button" onClick={() => updatepassword()}>
//                           Update Password
//                         </button>
//                       </div>
//                     </div>
//                   )}
//                   {isusername && (
//                     <div>
//                       <div className="input-block nomargin">
//                         <label className="labelheading logpaddingleft15">
//                           Enter First Name{" "}
//                         </label>
//                       </div>
//                       <div className="input-block nomargin">
//                         <div className="passtextboxnew1">
//                           <input
//                             type="text"
//                             placeholder="Enter First Name"
//                             value={newuserfirstname}
//                             onChange={handlenewusername}
//                             name="newuserfirstname"
//                             autoComplete="off"
//                           />
//                         </div>
//                         {newuserfirstnameerror != "" && (
//                           <div className="errormsg1">{newuserfirstnameerror}</div>
//                         )}
//                       </div>
//                       <div className="input-block nomargin">
//                         <label className="labelheading logpaddingleft15">
//                           Enter Last Name{" "}
//                         </label>
//                       </div>
//                       <div className="input-block nomargin">
//                         <div className="passtextboxnew1">
//                           <input
//                             type="text"
//                             placeholder="Enter Last Name"
//                             name="newuserlastname"
//                             onChange={handlenewuserlastname}
//                             value={newuserlastname}
//                             autoComplete="off"
//                           />
//                         </div>
//                         {newuserlastnameerror != "" && (
//                           <div className="errormsg1">{newuserlastnameerror}</div>
//                         )}
//                       </div>
//                       {/* <div>
//                                           <div className="input-block nomargin label">
//                                               <label className="labelheading paddingleft15">Enter Your Mobile Number : </label>
//                                           </div>
//                                           <div className="input-block nomargin">
//                                               <div className="passtextboxnew1">
//                                                   <input type="text" placeholder="Enter Your Mobile Number" name="mob_no" onChange={handleNewUserMobileNumberNew} value={mob_no} autoComplete="off" />
//                                                   {newUserMoberror != '' && <div className="errormsg">{newUserMoberror}</div>}
//                                               </div>
//                                           </div>
//                                       </div> */}
//                       <div className="divheight30"></div>
  
//                       {/* <div className="input-block">
//                                           <button type="button" onClick={() => updatefirstlastname()}>Update</button>
                            
//                                       </div> */}
//                       {loadingshow ? (
//                         <>
//                           <div className="input-block_disable">
//                             <button type="button" disabled>
//                               Update
//                             </button>
//                           </div>
//                           <div className="textcenter">
//                             <Vortex
//                               visible={true}
//                               height="80"
//                               width="80"
//                               ariaLabel="vortex-loading"
//                               wrapperStyle={{}}
//                               wrapperClass="vortex-wrapper"
//                               colors={[
//                                 "#0473ea",
//                                 "#0473ea",
//                                 "#0473ea",
//                                 "#39d800",
//                                 "#39d800",
//                                 "#39d800",
//                               ]}
//                             />
//                             <div className="model_popup">loading data..</div>
//                           </div>
//                         </>
//                       ) : (
//                         <div className="input-block">
//                           <button
//                             type="button"
//                             onClick={() => updatefirstlastname()}
//                           >
//                             Update
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   )}
//                   {isthankyou && (
//                     <div>
//                       <div className="input-block">
//                         <label className="labelheading">
//                           Thank you for Registration.
//                         </label>
//                         <label className="labelheading">
//                           Please{" "}
//                           <a className="link" onClick={routeChange}>
//                             Login
//                           </a>{" "}
//                           with your email and password.
//                         </label>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </Modal.Body>
//             </Modal>
//           </Container>
//         </div>
//       </>
//     );
//   }
//   export default React.forwardRef(LoginPopup);

// // -----------------------------------------new signup ui 01-01-2024 end code -----------------------------------------



